/** Récupère un élément obligatoire ; son absence est un bug d'index.html. */
export const requireElement = (selector: string): HTMLElement => {
  const element = document.querySelector<HTMLElement>(selector);
  if (!element)
    throw new Error(`Élément introuvable pour le sélecteur "${selector}"`);
  return element;
};
